<template>
  <DashboardContainer :sidebarItems="this.sidebarItems">
    <div class="data-table mt-8">
      <div class="data-table__scroll">
        <table class="data-table__table">
          <thead class="data-table__head">
            <tr>
              <th scope="col" class="data-table__head-cell">Name</th>
            </tr>
          </thead>
          <tbody class="data-table__body">
            <tr v-for="npo in npos" :key="npo.id" class="data-table__row">
              <td class="data-table__cell">
                <span class="data-table__primary-text">{{ npo.name }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </DashboardContainer>
</template>

<script>
import { ref } from 'vue'
import { useStore } from 'vuex'
import { DialogTitle } from '@headlessui/vue'
import DashboardContainer from '../components/DashboardContainer.vue'
import { BuildingLibraryIcon, MegaphoneIcon } from '@heroicons/vue/20/solid'

export default {
  name: 'npos',
  components: {
    DashboardContainer,
    DialogTitle,
  },
  setup() {
    const npos = ref()
    const store = useStore()
    const usersGroups = store.getters.userGroups
    const sidebarItems = [
      {
        name: 'Campaigns',
        url: '/campaigns',
        icon: MegaphoneIcon,
        current: false,
        allowedGroups: ['Givaroo Staff', 'NPO Admin'],
        visible: false,
      },
    ]

    function checkPermissions(usersGroupsArr) {
      for (let i = 0; i < sidebarItems.length; i++) {
        let { allowedGroups } = sidebarItems[i]
        if (allowedGroups.filter((x) => usersGroupsArr.includes(x)).length) {
          sidebarItems[i].visible = true
        }
      }
    }

    checkPermissions(usersGroups)

    return {
      sidebarItems,
      npos,
    }
  },
  mounted() {
    const url = '/api/nonprofits/'
    const options = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }
    fetch(url, options)
      .then((response) => response.json())
      .then((response) => {
        this.npos = response.results
        return response
      })
      .catch((err) => console.log(err.message))
  },
}
</script>
